import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

export interface EmptyRowProps {
  colSpan: number;
  message: string;
}

export function EmptyRow({ colSpan, message }: Readonly<EmptyRowProps>): React.JSX.Element {
  return (
    <TableRow>
      <TableCell colSpan={colSpan}>
        <Typography sx={{ opacity: 0.7, py: 1 }}>{message}</Typography>
      </TableCell>
    </TableRow>
  );
}

export default EmptyRow;
